import { render, staticRenderFns } from "./VuexHistory.vue?vue&type=template&id=4d60ca09&scoped=true&"
import script from "./VuexHistory.vue?vue&type=script&lang=js&"
export * from "./VuexHistory.vue?vue&type=script&lang=js&"
import style0 from "./VuexHistory.vue?vue&type=style&index=0&id=4d60ca09&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d60ca09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d60ca09')) {
      api.createRecord('4d60ca09', component.options)
    } else {
      api.reload('4d60ca09', component.options)
    }
    module.hot.accept("./VuexHistory.vue?vue&type=template&id=4d60ca09&scoped=true&", function () {
      api.rerender('4d60ca09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/vuex/VuexHistory.vue"
export default component.exports